
import { SearchType } from './state/ViewTypes';

export function getSortingGroup(type: SearchType): SearchType[] {
  const sortingGroups: SearchType[][] = [['CONTEXT', 'EXACT'], ['DOCUMENT'], ['FOLDER'], ['GRAPH']];

  const allGroups = sortingGroups.flat();

  const selectedSortingGroup = sortingGroups.find((group) => group.includes(type));

  return selectedSortingGroup
    ? allGroups.filter((option) => selectedSortingGroup.includes(option))
    : [];
}
